<template>
  <div class="main-wrapper">
    <div class="btn-wrapper">
      <el-button icon="el-icon-plus" type="primary" @click="addModal('新增用户')">新增用户</el-button>
      <el-button icon="el-icon-download" type="primary" @click="exportExcel('用户列表')">导出</el-button>
    </div>
    <ex-table showPagination :data="tableData" :height="tableHeight" ref="table"
              :search-method="handleChange" border>
      <ex-table-col prop="userName" label="用户名"></ex-table-col>
      <ex-table-col prop="name" label="姓名"></ex-table-col>
      <ex-table-col prop="phoneNumber" label="电话号码"></ex-table-col>
      <ex-table-col prop="birthday" label="生日"></ex-table-col>
      <ex-table-col prop="sexName" label="性别"></ex-table-col>
      <ex-table-col prop="createDate" label="注册时间"></ex-table-col>
      <ex-table-col prop="isStart" label="是否启用">
        <template slot-scope="scope">
          <el-switch
            style="margin-left: 8px;"
            @change="startChange(scope.row)"
            v-model="scope.row.isStart"
            active-value="1"
            inactive-value="0"
            active-text="是"
            inactive-text="否">
        </el-switch>
        </template>
      </ex-table-col>
      <ex-table-col :width="100" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button title="编辑" class="circle-btn" type="primary" @click="edit(scope.row)" icon="el-icon-edit" circle></el-button>
          <el-button title="删除" class="circle-btn" type="primary" @click="remove(scope.row.id)" icon="el-icon-delete" circle></el-button>
        </template>
      </ex-table-col>
    </ex-table>
    <edit-modal :row-id="currentId" :title="currentTitle" v-if="isShowEdit" @ok="onModalOk" @close="isShowEdit=false" :mode="editMode"></edit-modal>
  </div>
</template>
<script>
  import pageMixin from "@/mixin/tablePage"
  import editModal from "./edit"
  import {putAction} from "@/service/http/api";

  export default {
    name:'UserManagement',
    mixins:[pageMixin],
    components:{
      'edit-modal':editModal
    },
    data(){
      return{
        tableHeight: window.innerHeight - 290,
        page: 1,
        pageSize: 10,
        tableData:[],
        currentId:null,
        isShowEdit:false,
        currentTitle:null,
        editMode:'new',
        reqParams:{},
        url:{
          list:'/login/getAllUsers',
          download:'/login/exportUserExcel',
          remove:'/login/delete',
          edit:'/login/edit'
        }
      }
    },
    methods:{
      setRole(id){

      },
      edit(row){
        this.currentTitle = '编辑' + row.userName ;
        this.currentId = row.id;
        this.editMode = 'edit';
        this.isShowEdit = true;
      },
      startChange(row){
        putAction(this.url.edit,row).then(res=>{
          if(res.code===200){
            this.$message({
              message:'保存成功',
              type:"success"
            });
          }
          this.loadData();
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/user_management/user_management.vue